define(['wixappsCore/core/styleMap.json'], function (styleMap) {
    'use strict';

    function getDefaultSkinName(compName) {
        return styleMap[compName] && styleMap[compName].default && styleMap[compName].default.skin;
    }

    function getSkinAndStyle(allTheme, proxyName, styleNS, styleId, skin) { // eslint-disable-line complexity
        if (skin && styleId && allTheme[styleId]) {
            return {skin, styleId};
        } else if (skin) {
            return {skin};
        }

        const styleObj = styleMap[proxyName][styleNS] || styleMap[proxyName].default;
        styleId = styleId || styleObj.style;

        if (styleId && allTheme[styleId]) {
            return {
                styleId,
                skin: allTheme[styleId].skin
            };
        }

        return {
            styleId: styleObj.style,
            skin: styleObj.skin
        };
    }

    /**
     * @class wixappsCore.styleData
     */
    return {
        getDefaultSkinName,
        getSkinAndStyle
    };
});
